import { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Alert } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useChangePassword } from "../../../../core/store/auth/register/thunk";
import './style-for-folder.css';

const ChangePassword = ({ onSuccess }) => {
  const { handleChangePassword, loading, error: apiError, setError: setApiError } = useChangePassword();
  const [error, setError] = useState(apiError || null);
  const [successMessage, setSuccessMessage] = useState("");

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmationPassword: "",
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required("L'ancien mot de passe est requis"),
      newPassword: Yup.string()
        .min(6, "Le mot de passe doit contenir au moins 6 caractères")
        .required("Nouveau mot de passe requis"),
      confirmationPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Les mots de passe doivent correspondre")
        .required("Veuillez confirmer votre mot de passe"),
    }),
    onSubmit: async (values, { resetForm }) => {
      console.log('Début de la soumission', values); // Log de débogage
      try {
        setError(null);
        setSuccessMessage("");
        
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        const token = authUser?.data?.token;
        
        console.log('Token récupéré:', token); // Log de débogage
        
        if (!token) {
          const err = new Error("Session expirée. Veuillez vous reconnecter.");
          console.error('Erreur de token:', err); // Log de débogage
          throw err;
        }
    
        const data = {
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
          token: token
        };
    
        console.log('Appel à handleChangePassword avec:', data); // Log de débogage
        const response = await handleChangePassword({
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
        });
        console.log('Réponse de handleChangePassword:', response); // Log de débogage
        
       
        resetForm();
       
      } catch (error) {
        console.error('Erreur lors de la soumission:', { // Log de débogage détaillé
          message: error.message,
          response: error.response,
          stack: error.stack,
          fullError: error
        });
        const errorMessage = error.response?.data?.message || error.message || "Une erreur est survenue lors du changement de mot de passe";
        setError(errorMessage);
        if (setApiError) {
          setApiError(errorMessage);
        }
      }
    },
  });

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100">
      <Row className="justify-content-center" style={{width:"100%",height:"100%"}}>
        <Col md={10} lg={10} xl={10}>
          <Card className="shadow-lg border-0 rounded-4 overflow-hidden">
            <Card.Header className="bg-primary bg-gradient py-4 border-0">
              <div className="text-center">
                <i className="fas fa-key fa-3x text-white mb-3"></i>
                <h3 className="h4 text-white mb-0">Changer votre mot de passe</h3>
                <p className="text-white-50 mb-0 mt-2">
                  Sécurisez votre compte avec un nouveau mot de passe
                </p>
              </div>
            </Card.Header>

            <Card.Body className="p-4 p-md-5">
              {error && (
                <Alert
                  variant="danger"
                  className="rounded-3"
                  dismissible
                  onClose={() => setError(null)}
                >
                  <i className="fas fa-exclamation-circle me-2"></i>
                  {error}
                </Alert>
              )}

              {successMessage && (
                <Alert
                  variant="success"
                  className="rounded-3"
                  dismissible
                  onClose={() => setSuccessMessage("")}
                >
                  <i className="fas fa-check-circle me-2"></i>
                  {successMessage}
                </Alert>
              )}

              <Form onSubmit={formik.handleSubmit} className="mt-4">
                <Form.Group className="mb-4">
                  <Form.Label className="fw-medium text-muted">
                    <i className="fas fa-lock me-2 text-primary"></i>
                    Ancien mot de passe
                  </Form.Label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <i className="fas fa-key text-muted"></i>
                    </span>
                    <Form.Control
                      type="password"
                      name="currentPassword"
                      value={formik.values.currentPassword}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={formik.touched.currentPassword && formik.errors.currentPassword}
                      placeholder="Entrez votre mot de passe actuel"
                      className="py-2"
                    />
                    <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                      <i className="fas fa-exclamation-circle me-2"></i>
                      {formik.errors.currentPassword}
                    </Form.Control.Feedback>
                  </div>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-medium text-muted">
                    <i className="fas fa-lock me-2 text-primary"></i>
                    Nouveau mot de passe
                  </Form.Label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <i className="fas fa-key text-muted"></i>
                    </span>
                    <Form.Control
                      type="password"
                      name="newPassword"
                      value={formik.values.newPassword}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={formik.touched.newPassword && formik.errors.newPassword}
                      placeholder="Créez un nouveau mot de passe"
                      className="py-2"
                    />
                    <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                      <i className="fas fa-exclamation-circle me-2"></i>
                      {formik.errors.newPassword}
                    </Form.Control.Feedback>
                  </div>
                  <Form.Text className="text-muted small mt-1 d-block">
                    Le mot de passe doit contenir au moins 6 caractères.
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-medium text-muted">
                    <i className="fas fa-redo me-2 text-primary"></i>
                    Confirmez le mot de passe
                  </Form.Label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <i className="fas fa-key text-muted"></i>
                    </span>
                    <Form.Control
                      type="password"
                      name="confirmationPassword"
                      value={formik.values.confirmationPassword}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={formik.touched.confirmationPassword && formik.errors.confirmationPassword}
                      placeholder="Confirmez votre nouveau mot de passe"
                      className="py-2"
                    />
                    <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                      <i className="fas fa-exclamation-circle me-2"></i>
                      {formik.errors.confirmationPassword}
                    </Form.Control.Feedback>
                  </div>
                </Form.Group>

                <div className="d-flex justify-content-between mt-5 pt-3 border-top">
                  <Button 
                    variant="outline-secondary" 
                    type="button" 
                    onClick={() => {
                      formik.resetForm();
                      setError(null);
                      setSuccessMessage("");
                    }}
                    className="px-4 py-2 rounded-3 d-flex align-items-center"
                    disabled={loading}
                  >
                    <i className="fas fa-times me-2"></i>
                    Annuler
                  </Button>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    disabled={loading}
                    className="px-4 py-2 rounded-3 d-flex align-items-center"
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Modification...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-save me-2"></i>
                        Changer le mot de passe
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ChangePassword;